// FIXME: THIS WILL INCREASE THE BUNDLE SIZE, BARREL FILE SHOULD BE AVOIDED
export { default as Text } from './Text/Text';
export { default as Title } from './Title/Title';
export { default as TitleFeatured } from './TitleFeatured/TitleFeatured';
export { default as PageHeader } from './PageHeader/PageHeader';
